<template>
    <b-card>
      <!-- Siblings Details -->
      <div class="section-container">
        <b-row align-v="center">
          <b-col md="12">
            <h5 class="text-uppercase text-info font-weight-bold" style="display: flex; align-items: center">
              <i class="fas fa-user-friends mr-1"></i>Siblings Details
            </h5>
          </b-col>
        </b-row>
  
        <b-row v-if="siblings && siblings.length > 0" align-v="center" class="mb-3">
          <b-col md="12">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark text-left">
                <tr>
                  <th class="font-weight-bold">Name</th>
                  <th class="font-weight-bold">Relationship</th>
                  <th class="font-weight-bold">Education</th>
                  <th class="font-weight-bold">Occupation</th>
                  <th class="font-weight-bold">Annual Income</th>
                  <th class="font-weight-bold">Mobile Number</th>
                  <th class="font-weight-bold">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sibling, sIndex) in siblings" :key="sIndex">
                  <td>{{ sibling.name }}</td>
                  <td>{{ capitalizeFirstLetter(sibling.relationship) }}</td>
                  <td>{{ sibling.education }}</td>
                  <td>{{ sibling.occupation }}</td>
                  <td>{{ sibling.annual_income }}</td>
                  <td>{{ sibling.phone_number }}</td>
                  <td>{{ sibling.email }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </template>
  
  <script>
  export default {
    name: "SiblingsDetails",
    props: {
      siblings: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      }
    }
  };
  </script>
  <style scoped>
  .section-container {
      padding: 14px;
      background-color: #f9f9f9;
      border-radius: 0px;
  }
  
  .capitalize {
      text-transform: capitalize;
  }
  </style>
  